import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pos-diagnostics',
  templateUrl: './pos-diagnostics.component.html',
  styleUrls: ['./pos-diagnostics.component.scss']
})
export class PosDiagnosticsComponent {
  @Input() storeId: string = '';

  activeSection: 'events' | 'session' | 'kiosk-builds' | 'webapp-updates' | 'terminal-health' = 'events';
  sessionIdFromList: string = '';

  setSection(section: 'events' | 'session' | 'kiosk-builds' | 'webapp-updates' | 'terminal-health'): void {
    this.activeSection = section;
  }

  openSessionTimeline(sessionId: string): void {
    this.sessionIdFromList = sessionId;
    this.activeSection = 'session';
  }
}
